module.exports = __webpack_public_path__ + "media/images/check1-0daf0d62cec4f134dd321c39accf429f.svg";